import { SignatureInfo } from "../../../../../../types/renter.type";

type FormPropsDisplayContractLink = {
  contractInfo: SignatureInfo;
};

export default function ZapSignConfirmation(props: FormPropsDisplayContractLink) {

  return (
    <div className="grid-class">
      <div>
        <h2 className="font-semibold text-bluePrimary">
          <a href={props?.contractInfo?.data.signers[0].sign_url} target="_blank">
            {props?.contractInfo?.data.signers[0].sign_url}
          </a>
        </h2>
      </div>
    </div>
  )
}
